module.exports = __webpack_public_path__ + "assets/img/prize-photo.63582a28.png";